import { Controller } from "@hotwired/stimulus"
import Datepicker from 'flowbite-datepicker/Datepicker';

export default class extends Controller {
  connect() {
    this.flowbiteDatePicker = new Datepicker(this.element, {
        autohide: this.element.hasAttribute("datepicker-autohide"),
        format: this.element.getAttribute("datepicker-format")
    });
  }
}